export const add48HoursToDate = (date: string): string => {
    const formattedDate = new Date(date);
    formattedDate.setHours(formattedDate.getHours() + 48);
    return formattedDate.toLocaleDateString();
};

export const oneYearAheadToCurrentDate = () => {
    const now = new Date();
    const endDate = new Date(now.getTime());
    endDate.setFullYear(now.getFullYear() + 1);
    return endDate.toLocaleDateString();
};

export const isTodaysDate = (dateString: string): Boolean => {
    var inputDate = new Date(dateString);
    var today = new Date();
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return inputDate.getTime() === today.getTime();
};
